export default __webpack_public_path__ + "static/media/icon-back.ce1ea32c.svg";